import * as React from "react";
import { useUpdater } from "@/utils/callbacks";
import {
  ExistingOccupierErrors,
  errorsOfExistingOccupier,
  ExistingOccupier,
  ExistingOccupierFields,
} from "./ExistingOccupierFields";
import { cleanedErrors } from "@/utils/Functions";
import { Property } from "@/types/property";
import { Person } from "@/types";

export type Record = {
  readonly occupier?: ExistingOccupier;
};

export type Errors = undefined | { readonly occupier?: ExistingOccupierErrors };

export const errorsOf: (r?: Record) => Errors = (r) => {
  return cleanedErrors({
    occupier: errorsOfExistingOccupier(r?.occupier),
  });
};

export const existingOccupierInfoAvailable = (property: Property) => {
  return property.occupierId;
};

export const existingOccupierPropertyFieldsFromRecord = (record?: Record): Partial<Property> => {
  if (!record) return {};
  return {
    occupier: {
      id: record.occupier?.responsibleId || undefined,
      details: record.occupier?.responsible,
    },
  };
};

export type ExistingOccupierPropertyFieldsProps = {
  readonly serviceProvider: { customForm?: string };
  readonly persons: ReadonlyArray<Person>;
  readonly record: Record;
  readonly update: any;
  readonly errors: Errors;
};

export const ExistingOccupierPropertyFields: React.FC<ExistingOccupierPropertyFieldsProps> = ({
  serviceProvider,
  persons,
  record,
  update,
  errors,
}) => {
  const updateAccountHolder = useUpdater(update, "occupier");

  return (
    <ExistingOccupierFields
      serviceProvider={serviceProvider}
      persons={persons}
      record={record.occupier || {}}
      errors={errors?.occupier}
      update={updateAccountHolder}
    />
  );
};
